import { ICustomerQuote } from 'quotes/types';

export const getDefaultValuesFromQuote = (
  quote: ICustomerQuote,
  isAlternateVersionEnabled: boolean
) => {
  if (!quote) {
    return {};
  }

  const quoteLocation = quote.location;

  return {
    location: quoteLocation
      ? {
          ...quoteLocation,
          vendorId: isAlternateVersionEnabled
            ? quoteLocation.externalLocationId
            : quoteLocation.vendorIdentifier,
        }
      : null,
    ...(isAlternateVersionEnabled && {
      isr: quote.isr,
      osr: quote.osr,
    }),
  };
};
